import { render, staticRenderFns } from "./ServicePointGrid.vue?vue&type=template&id=5bd20a88&scoped=true&"
import script from "./ServicePointGrid.vue?vue&type=script&lang=ts&"
export * from "./ServicePointGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointGrid.vue?vue&type=style&index=0&id=5bd20a88&prod&lang=css&"
import style1 from "./ServicePointGrid.vue?vue&type=style&index=1&id=5bd20a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd20a88",
  null
  
)

export default component.exports